window.ELEMENTS_TYPES = {
    'text': 'text',
    'link': 'link',
    'user': 'user',
    'rich_text_section': 'rich_text_section',
    'rich_text_list': 'rich_text_list',
    'blockquote': 'blockquote',
    'dynamic_field': 'dynamic_field'
};

window.CH_LIST_TYPES = {
    'ORDERED': 'ordered',
    'BULLET': 'bullet'
};

window.urlPattern = /^(((http|https):\/\/\S*)|(?:(?:www\.)?[\w-]+(?:\.[\w-]+)*\.(?:ps|us|uk|com|net|live|gov|edu|org|co|app|io|ai|me|info|online|site|store){1,}((?:\/[\w-]+)*)+(?:\/[\w-]+)*(?:\/)?))$/;

window.createContentElementStyle = function () {
    return {
        bold: undefined,
        italic: undefined,
        strike: undefined,
        under_line: undefined,
        list_type: undefined
    };
}

window.createContentElements = function () {
    return {
        type: undefined,
        url: undefined,
        style: undefined,
        elements: undefined,
        text: undefined,
        user_id: undefined,
        all: undefined,
        user_name: undefined
    };
}

window._messageText = '';

window.getChObjectMessage = function (htmlString, parentPayLoad, isRoot) {
    _messageText = '';
    var components = getMessageContent(htmlString, {payload: parentPayLoad}, [], isRoot);
    return{
        content: {
            text: _messageText,
            components: [components]
        }
    };
}

window.getMessageContent = function (htmlString, parentReference, userMap, isRoot, ignoreNewLine) {
    let parentPayLoad = parentReference.payload;
    var payload = createContentElements();
    let payloadReference = {
        payload,
        parentReference,
        tailItems: []
    }
    var root = typeof htmlString === 'string' ? convertStringToHTML(htmlString) : htmlString;
    if (root.nodeType !== 3) {
        if (root.nodeName === 'UL') {
            payload.type = ELEMENTS_TYPES.rich_text_list;
            payload.style = payload.style || createContentElementStyle();
            payload.style.list_type = CH_LIST_TYPES.BULLET;
        } else if (root.nodeName === 'OL') {
            payload.type = ELEMENTS_TYPES.rich_text_list;
            payload.style = payload.style || createContentElementStyle();
            payload.style.list_type = CH_LIST_TYPES.ORDERED;
        } else if (root.nodeName === 'BLOCKQUOTE') {
            payload.type = ELEMENTS_TYPES.blockquote;
        } else {
            payload.type = ELEMENTS_TYPES.rich_text_section;
        }
        if (root.nodeName === 'B' || root.nodeName === 'STRONG') {
            payload.style = payload.style || createContentElementStyle();
            payload.style.bold = true;
        }

        if (root.nodeName === 'U') {
            payload.style = payload.style || createContentElementStyle();
            payload.style.under_line = true;
        }

        if (root.nodeName === 'I') {
            payload.style = payload.style || createContentElementStyle();
            payload.style.italic = true;
        }

        if (root.nodeName === 'STRIKE') {
            payload.style = payload.style || createContentElementStyle();
            payload.style.strike = true;
        }
    }
    payload['elements'] = [];
    if (root.nodeName === 'DIV' && !(root.childNodes.length && ['DIV', 'BLOCKQUOTE'].includes(root.childNodes[0].nodeName)) && !isRoot && !ignoreNewLine) {
        payload['elements'].push({
            type: ELEMENTS_TYPES.text,
            text: '\n'
        });
        _messageText += '\n';
    }
    for (var i = 0; i < root.childNodes.length; i++) {
        let prepend = i === 0;
        if ((root.childNodes[i].nodeName === 'SPAN' && (root.childNodes[i]['classList'].contains('user-mention') ||
                root.childNodes[i]['classList'].contains('h-dynamic-field'))) ||
            root.childNodes[i].nodeName === '#text') {
            var element = createContentElements();
            if (root.childNodes[i].nodeName === '#text') {
                element.type = ELEMENTS_TYPES.text;
                element.text = root.childNodes[i].textContent || '';
                _messageText += element.text;
            } else if (root.childNodes[i]['classList'].contains('user-mention')) {
                element.type = ELEMENTS_TYPES.user;
                element.text = '';
                element.user_id = ((root.childNodes[i]['attributes']['field-code'] || {}).value) || root.childNodes[i].textContent || '';
                if (element.user_id) {
                    if (userMap && userMap[element.user_id]) {
                        element.user_name = userMap[element.user_id].first_name + ' ' + userMap[element.user_id].last_name;
                        element.first_name = userMap[element.user_id].first_name;
                        element.last_name = userMap[element.user_id].last_name;
                        element.known_as = userMap[element.user_id].known_as;
                        element.all = userMap[element.user_id].id === 'all';
                        if (element.all) {
                            delete element.user_id
                        }
                    } else {//when user map not passed to the function like in mobile version
                        var userName = root.childNodes[i].textContent || '';
                        element.user_name = userName.charAt(0) === '@'? userName.substring(1) : userName;
                        element.all = (userName.charAt(0) === '@' && userName.substring(1) === 'all');
                    }
                    if (element.user_id === 'all') {
                        element.all = true;
                        delete element.user_id;
                    }
                }
                _messageText += (element.text || element.user_name);
            } else {
                element.type = ELEMENTS_TYPES.dynamic_field;
                element.text = '';
                element.field_code = root.childNodes[i]['attributes']['field-code'].value;
                element.field_name = root.childNodes[i].textContent;
                _messageText += '{' + element.field_code + '}';
            }
            if ((parentPayLoad.style && parentPayLoad.style.bold) ||
                (payload.style && payload.style.bold)) {
                element.style = element.style || createContentElementStyle();
                element.style.bold = true;
            }
            if ((parentPayLoad.style && parentPayLoad.style.italic) ||
                (payload.style && payload.style.italic)) {
                element.style = element.style || createContentElementStyle();
                element.style.italic = true;
            }
            if ((parentPayLoad.style && parentPayLoad.style.strike) ||
                (payload.style && payload.style.strike)) {
                element.style = element.style || createContentElementStyle();
                element.style.strike = true;
            }
            if ((parentPayLoad.style && parentPayLoad.style.under_line) ||
                (payload.style && payload.style.under_line)) {
                element.style = element.style || createContentElementStyle();
                element.style.under_line = true;
            }
            pushElementToPayload(element, payloadReference, prepend);
        } else if (root.childNodes[i].nodeName === 'A') {
            var element = createContentElements();
            element.type = ELEMENTS_TYPES.link;
            element.text = root.childNodes[i].textContent || '';
            element.url = root.childNodes[i]['href'] || '';
            pushElementToPayload(element, payloadReference, prepend);
            _messageText += element.text;
        } else if (root.childNodes[i].nodeName === 'BR') {
            pushElementToPayload({
                type: ELEMENTS_TYPES.text,
                text: '\n'
            }, payloadReference, prepend);
            _messageText += '\n';
        } else {
            var ignoreNL = ['BLOCKQUOTE'].includes(root.nodeName) && i ===0;
            pushElementToPayload(getMessageContent(root.childNodes[i], payloadReference, userMap, false, ignoreNL), payloadReference, prepend);
        }
    }
    payload.elements = [...payload.elements, ...payloadReference.tailItems]
    return payload;
}

window.pushElementToPayload = function (element, payloadReference, prepend, movedElement) {
    if (payloadReference.payload.type === ELEMENTS_TYPES.rich_text_list && element.type !== ELEMENTS_TYPES.rich_text_section) {
        pushElementToPayload(element, payloadReference.parentReference, prepend, true)
    } else {
        if (movedElement && !prepend) {
            payloadReference.tailItems.push(element);
        } else {
            payloadReference.payload.elements.push(element);
        }
    }
}

window.getMessageContentAsHtml = function (components, isList, isEmployee) {
    var html = "";
    if (components) {
        for (var i = 0; i < components.length; i++) {
            var htmlBlock = "";
            if (components[i].type === ELEMENTS_TYPES.text) {
                htmlBlock += components[i].text;
                var urlRegex = new RegExp(urlPattern, 'g');
                htmlBlock = htmlBlock.replace(urlRegex, function(url){
                    var httpsText = '';
                    if(!url.startsWith('http://') && !url.startsWith('https://')) {
                        httpsText = 'https://';
                    }
                    return '<a target="_blank" href="' + httpsText + url + '">' + url + '</a>';
                });
            } else if (components[i].type === ELEMENTS_TYPES.user) {
                htmlBlock += `<span field-code="${components[i].user_id}" class="user-mention" contenteditable="false">`
                    +`@` + getUserDisplayName(components[i], isEmployee)
                    +`</span>`;
            }  else if (components[i].type === ELEMENTS_TYPES.dynamic_field) {
                htmlBlock += '<span field-code="' + components[i].field_code + '" class="h-dynamic-field" contenteditable="false">' + components[i].field_name + '</span>';
            } else if (components[i].type === ELEMENTS_TYPES.link) {
                htmlBlock += '<a href="' + components[i].url + '" >' + components[i].text + '</a>';
            } else if (components[i].type === ELEMENTS_TYPES.rich_text_section) {
                if (isList) {
                    htmlBlock += "<li>" + getMessageContentAsHtml(components[i].elements, false, isEmployee) + "</li>";
                } else {
                    htmlBlock += getMessageContentAsHtml(components[i].elements, false, isEmployee);
                }
                var style = components[i].style;
                if (style && style.bold) {
                    htmlBlock = "<b>" + htmlBlock + "</b>";
                }
                if (style && style.italic) {
                    htmlBlock = "<i>" + htmlBlock + "</i>";
                }
                if (style && style.strike) {
                    htmlBlock = "<strike>" + htmlBlock + "</strike>";
                }
                if (style && style.under_line) {
                    htmlBlock = "<u>" + htmlBlock + "</u>";
                }
            } else if (components[i].type === ELEMENTS_TYPES.rich_text_list) {
                var listStyle = components[i].style;
                if (listStyle && listStyle.list_type === CH_LIST_TYPES.BULLET) {
                    htmlBlock += "<ul>" + getMessageContentAsHtml(components[i].elements, true, isEmployee) + "</ul>";
                } else {
                    htmlBlock += "<ol>" + getMessageContentAsHtml(components[i].elements, true, isEmployee) + "</ol>";
                }
            } else if (components[i].type === ELEMENTS_TYPES.blockquote) {
                htmlBlock += "<blockquote>" + getMessageContentAsHtml(components[i].elements, false, isEmployee) + "</blockquote>";
            }
            html += htmlBlock;
        }
    }
    html = html.replace(/\n/g, '<br>');
    return html;
}

window.convertStringToHTML = function (str) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(str, 'text/html');
    if (doc.body.childNodes.length > 1) {
        return doc.body;
    } else {
        return doc.body.childNodes[0];
    }
}

window.getUserDisplayName = function (user, isEmployee) {
    if (user.known_as || user.first_name|| user.last_name) {
        return `${(isEmployee && user.known_as) ? user.known_as : user.first_name} ${user.last_name}`
    }
    // When edit a sent message before refreshing the page, it will not has (known_as, first_name, and last_name). Then we should use "user_name"
    else {
        return user.user_name;
    }
}

window.chMessageTransform = {
    getMessageContentAsHtml: getMessageContentAsHtml,
    getMessageContent: getMessageContent,
    get messageText() {
        return _messageText;
    },
    set messageText(msg) {
        _messageText = msg;
    }
};
